<template>
  <div class="StaffManage-list">
    <GlobalInfoBar
      title="礼包设置"
      content="配置线上回收,顾客到店回收礼包赠品管理"
    />
    <GlobalChunk icon="search" title="筛选查询">
      <div slot="filter">
        <From />
      </div>
      <Table />
    </GlobalChunk>
  </div>
</template>

<script >
export default {
  components: {
    From: () => import("./from"),
    Table: () => import("./table"),
  },
  data() {
    return {
    };
  },
  created() {},
  mounted() {},
  methods: {},
};
</script>

<style scoped lang="scss" ref="stylesheet/scss">
</style>
